import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import NumericEnum from '@square/dashboard-utilities/utils/numeric-enum';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import { computed } from '@ember/object';
import { isPresent } from '@ember/utils';
export const SubscriptionStatus = NumericEnum.create(['DEFAULT_SUBSCRIPTION_STATUS_DO_NOT_USE', 'PENDING', 'ACTIVE', 'CANCELED', 'DEACTIVATED', 'PAUSED', 'COMPLETED']);

// Fields marked readOnly will not be sent to the server on PUT calls

// eslint-disable-next-line ember/no-classic-classes
export default Model.extend({
  locationId: attr('string'),
  plan: belongsTo('connect/subscription-plan', {
    readOnly: true
  }),
  planVariation: belongsTo('connect/subscription-plan/plan-variation', {
    readOnly: true
  }),
  startDate: attr('string'),
  canceledDate: attr('string'),
  billingEndDate: attr('string', {
    excludeFromCreate: true,
    readOnly: true
  }),
  chargedThroughDate: attr('string', {
    excludeFromCreate: true,
    readOnly: true
  }),
  completedDate: attr('string', {
    excludeFromCreate: true,
    readOnly: true
  }),
  status: attr('enum', {
    enumClass: SubscriptionStatus
  }),
  taxPercentage: attr('string'),
  customerId: attr('string'),
  invoiceIds: attr('array', {
    readOnly: true,
    excludeFromCreate: true,
    defaultValue: () => []
  }),
  lastInvoice: belongsTo('subscription-invoice', {
    readOnly: true,
    excludeFromCreate: true
  }),
  priceOverrideMoney: attr('object'),
  showBuyerSelfManagementToken: attr('boolean', {
    defaultValue: true,
    readOnly: true
  }),
  cardId: attr('string'),
  version: attr('number', {
    excludeFromCreate: true
  }),
  idempotencyKey: attr('string', {
    readOnly: true
  }),
  note: attr('string'),
  actions: fragmentArray('subscription-action', {
    readOnly: true,
    excludeFromCreate: true
  }),
  pendingPauseDate: attr('string', {
    readOnly: true,
    excludeFromCreate: true
  }),
  deletedContact: attr('boolean', {
    defaultValue: false,
    readOnly: true,
    excludeFromCreate: true
  }),
  customerName: attr('string', {
    readOnly: true,
    excludeFromCreate: true
  }),
  pendingResumeDate: attr('string', {
    readOnly: true,
    excludeFromCreate: true
  }),
  orderTemplateId: attr('string'),
  orderTemplateTotalMoney: attr('object', {
    readOnly: true,
    excludeFromCreate: true
  }),
  monthlyBillingAnchorDate: attr('number', {
    readOnly: true
  }),
  phases: hasMany('subscription-phase', {
    embedded: true,
    readOnly: true
  }),
  source: fragment('subscription-source'),
  isCanceled: computed('canceledDate', 'deletedContact', 'status', function () {
    return this.status === SubscriptionStatus.CANCELED || isPresent(this.canceledDate) || this.deletedContact;
  })
}).reopenClass({
  SubscriptionStatus
});